import axios from './api.js'

const state = {
    isDesktop: undefined,
    loginAgain: false,
    applicationSettings: {
        // forretningsområde koden 1-5 angiver pladsen i array'et
        kortinfoSettings: [null, null, null, null, null, null, null, null, null, null],
        showFieldSettings: null,
        pointStackSettings: {},
        allowedFileTypes: null
    },
    user: {},
    userInfo: {
        userId: null,
        name: null,
        phoneNumber: null,
        email: null,
        emailCc: null,
        organizationId: null,
        selectedOrganization: null,
        municipalityCodeList: null,
        permissions: {
            requests: {
                enabled: false
            },
            tasks: {
                enabled: false
            },
            requisitions: {
                enabled: false
            },
            kpi: {
                enabled: false
            }
        }
    },
    // notifyUser: {},
    organizationList: [
        {
            id: null,
            name: null,
            phone: null,
            address1: null,
            address2: null,
            postalCode: null,
            city: null,
            email: null,
            description: null,
            note: null
        }
    ],
    caseWorkers: [],
    entrepreneurs: [],
    enquiryId: '',
    allLists: {},
    objectsWithActivities: [],
    activitiesWithObjects: [],
    selectedSupplyType: {
        'id': null,
        'code': null,
        'description': null,
        'systemName': null
    },
    selectedMultipleSupplyType: [],
    selectedCaseworker: {
        userId: null,
        name: null,
        phoneNumber: null,
        email: null,
        emailCc: null,
        organizationId: null
    },
    routerHistory: '',
    existingEnquiriesFromAddress: '',
    existingTasksFromAddress: '',
    selectedOrganizationId: null,
    selectedOrganization: {},
    toggleMapState: false,
    facilityEndpoint: null,
    portalEndpoint: null
}

const getters = {
    getLoginAgain: state => {
        return state.loginAgain
    },
    user: state => {
        return state.user
    },
    getUserId: state => {
        return state.userInfo.userId
    },
    userInfo: state => {
        return state.userInfo
    },
    permissions: state => {
        return state.userInfo.permissions
    },
    organizationList: state => {
        return state.organizationList
    },
    getSelectedOrganization: state => {
        return state.selectedOrganization
    },
    caseWorkerList: state => {
        return state.caseWorkers.sort((a, b) => {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1 }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1 }
            return 0
        })
    },
    entrepreneursList: state => {
        return state.entrepreneurs.sort((a, b) => {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1 }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1 }
            return 0
        })
    },
    enquiryId: state => {
        return state.enquiryId
    },
    allLists: state => {
        return state.allLists
    },
    allListsActivity: state => {
        let sortedList = []
        for (let i in state.allLists.cActivityTypeList) {
            if (state.allLists.cActivityTypeList.hasOwnProperty(i)) {
                if (state.allLists.cActivityTypeList[i]) {
                    if (state.allLists.cActivityTypeList[i].businessAreaTypeId === state.selectedSupplyType.id) {
                        sortedList = state.allLists.cActivityTypeList[i].codeList
                    }
                }
            }
        }
        return sortedList.sort(function (a, b) {
            if (a.description < b.description) { return -1 }
            if (a.description > b.description) { return 1 }
            return 0
        })
    },
    getCActivityTypeList: state => {
        return state.allLists.cActivityTypeList
    },
    getSysBusinessAreaTypeList: state => {
        return state.allLists.sysBusinessAreaTypeList
    },
    getCClientTypeList: state => {
        return state.allLists.cClientTypeList
    },
    getEstateTypes: state => {
        return state.allLists.cEstateTypeList
    },
    getProblemTypes: state => {
        return state.allLists.cProblemTypeList
    },
    getWeatherTypes: state => {
        return state.allLists.cWeatherTypeList
    },
    getOrganizationUserList: state => {
        // Get the list of users associated with the current user, if the reponsible for the enquiry should be another user
        return state.user.Users
    },
    getSysRequisitionStatusTypeList: state => {
        return state.allLists.sysRequisitionStatusTypeList
    },
    getSysRequisitionAndReportStatusList: state => {
        return state.allLists.sysRequisitionAndReportStatusList
    },
    getSysRequestStatusTypeList: state => {
        return state.allLists.sysRequestStatusTypeList
    },
    getSysUnitOfTimeTypeList: state => {
        return state.allLists.sysUnitOfTimeTypeList
    },
    getSysRoutineIntervalTypeList: state => {
        return state.allLists.sysRoutineIntervalTypeList
    },
    objectsWithActivities: state => {
        return state.objectsWithActivities
    },
    selectedSupplyType: state => {
        return state.selectedSupplyType
    },
    selectedMultipleSupplyType: state => {
        return state.selectedMultipleSupplyType
    },
    getSelectedSupplyTypeId: state => {
        return state.selectedSupplyType.id
    },
    getSelectedCaseworker: state => {
        return state.selectedCaseworker
    },
    getRouterHistory: state => {
        return state.routerHistory
    },
    existingEnquiriesFromAddress: state => {
        return state.existingEnquiriesFromAddress
    },
    existingTasksFromAddress: state => {
        return state.existingTasksFromAddress
    },
    getApplicationSettings: state => {
        return state.applicationSettings
    },
    getToggleMapState: state => {
        return state.toggleMapState
    },
    getShowFieldSettings: state => {
        return state.applicationSettings.showFieldSettings
    },
    getFacilityEndpoint: state => {
        return state.facilityEndpoint
    },
    getPortalEndpoint: state => {
        return state.portalEndpoint
    }
}

const mutations = {
    setLoginAgain: (state, boolean) => {
        state.loginAgain = boolean
    },
    errorHandler: (state, error) => {
        console.error('error', error)
    },
    successHandler: (state, status) => {
        return status
    },
    updatePermissions: (state, payload) => {
        state.userInfo.permissions = payload
    },
    updateUserProperties: (state, payload) => {
        payload.forEach(element => {
            state.user[element.type] = element.value
        })
    },
    setCurrentUserInfo: (state, payload) => {
        let key = Object.keys(payload)
        let val = Object.values(payload)
        for (let i in key) {
            state.userInfo[key[i]] = val[i]
        }
    },
    setCurrentOrganzationList: (state, payload) => {
        state.organizationList = payload
    },
    setSelectedOrganization: (state, payload) => {
        state.selectedOrganization = state.organizationList.filter(organization => organization.id === payload.toLowerCase())[0]
        // Remove soon - this is obsolete and should be replaced by state.selectedOrganization
        state.selectedOrganizationId = state.selectedOrganization.id.toLowerCase()
    },
    setCaseworkers: (state, payload) => {
        state.caseWorkers = payload
    },
    setEntrepreneurs: (state, payload) => {
        state.entrepreneurs = payload
    },
    addAllLists: (state, payload) => {
        state.allLists = payload
    },
    addObjectsWithActivities: (state, payload) => {
        state.objectsWithActivities = payload
    },
    associateEnquiryWithTask: (state, payload) => {
        state.enquiryId = payload
    },
    setSelectedSupplyType: (state, payload) => {
        state.selectedSupplyType = {}
        var filteredSuppplyType = state.allLists.sysBusinessAreaTypeList.filter(supplyType => supplyType.sysBusinessAreaTypeId === payload)[0]
        if (filteredSuppplyType) {
            state.selectedSupplyType = {
                'id': filteredSuppplyType.sysBusinessAreaTypeId,
                'code': filteredSuppplyType.code,
                'description': filteredSuppplyType.description,
                'systemName': filteredSuppplyType.systemName
            }
        }
    },
    setSelectedMultipleSupplyType: (state, payload) => {
        let found = false
        var filteredSuppplyType = state.allLists.sysBusinessAreaTypeList.filter(supplyType => supplyType.sysBusinessAreaTypeId === payload)[0]
        if (filteredSuppplyType) {
            if (state.selectedMultipleSupplyType.length > 0) {
                state.selectedMultipleSupplyType.forEach((sup, index) => {
                    if (sup.code === filteredSuppplyType.code) {
                        found = true
                        state.selectedMultipleSupplyType.splice(index, 1)
                    }
                })
            }
            if (!found) {
                let supply = {
                    'id': filteredSuppplyType.sysBusinessAreaTypeId,
                    'code': filteredSuppplyType.code,
                    'description': filteredSuppplyType.description
                }
                state.selectedMultipleSupplyType.push(supply)
            }
        }
    },
    clearSelectedMultipleSupplyType: (state) => {
        state.selectedMultipleSupplyType = []
    },
    setSelectedCaseworker: (state, payload) => {
        state.selectedCaseworker = payload
    },
    setRouterHistory: (state, payload) => {
        state.routerHistory = payload
    },
    setExistingEnquiriesFromAddress: (state, payload) => {
        state.existingEnquiriesFromAddress = payload
    },
    setExistingTasksFromAddress: (state, payload) => {
        state.existingTasksFromAddress = payload
    },
    setApplicationSettings: (state, payload) => {
        payload.forEach((element) => {
            if (element.category === 'map') { // kortinfo_settings
                if (isNaN(element.name)) {
                    state.applicationSettings.kortinfoSettings[(element.name.toLowerCase())] = element.value
                } else {
                    state.applicationSettings.kortinfoSettings[parseInt(element.name)] = element.value
                }
            }
            if (element.name === 'address_list_filter' && element.value) {
                state.userInfo.municipalityCodeList = element.value.join(',')
            }
            if (element.name === 'show_fields') {
                state.applicationSettings.showFieldSettings = element.value
            }
            if (element.category === 'point_stack') {
                state.applicationSettings.pointStackSettings[element.name] = element.value
            }
            if (element.name === 'UploadPermittedExtensions') {
                state.applicationSettings.allowedFileTypes = element.value
            }

            if (element.name === 'FacilityEndpoint') {
                state.facilityEndpoint = element.value
            }
            if (element.name === 'PortalEndpoint') {
                state.portalEndpoint = element.value
            }
            if (element.name === 'ui') {
                state.applicationSettings.uiSettings = element.value
            }
            if (element.name === 'default_show_request_description_on_requisition') {
                state.applicationSettings.showRequestDescriptionOnRequisition = element.value
            }
            if (element.name === 'default_show_request_description_on_requisition') {
                state.applicationSettings.showRequestDescriptionOnRequisition = element.value
            }
        })
    },
    setSelectedOrganizationId: (state, payload) => {
        state.selectedOrganizationId = payload.toLowerCase() // this should not be necessary
    },
    setToggleMapState: (state, payload) => {
        state.toggleMapState = payload
    }
}

const actions = {
    setLoginAgain: ({ commit }, boolean) => {
        commit('setLoginAgain', boolean)
    },
    setIsDesktop: ({ commit }, boolean) => {
        state.isDesktop = boolean
    },
    // Get the user info
    setUserProperties: ({ dispatch, commit }, userProperties) => {
        commit('updateUserProperties', userProperties)
    },
    updateUser: ({commit, dispatch}, userInfo) => {
        let userObj = {
            phonenumber: userInfo.phoneNumber,
            name: userInfo.name
        }
        return axios.post('Account/UpdateUserinfo', userObj).then(() => {
            commit('setCurrentUserInfo', userInfo)
        }, error => {
            commit('errorHandler', error)
        })
    },
    getCurrentUserInfo: ({ commit, dispatch }, data) => {
        return new Promise((resolve, reject) => {
            return axios.post('/Account/GetCurrentUserInfo').then((response) => {
                commit('setCurrentUserInfo', response.data)
                resolve(response.data)
            })
        }).then(() => {
            if (data && data.claims) {
                return new Promise((resolve, reject) => {
                    resolve(dispatch('setPermissions', data.claims))
                })
            } else {
                return axios.post('/Account/GetClaims').then((response) => {
                    return new Promise((resolve, reject) => {
                        resolve(dispatch('setPermissions', response.data))
                    })
                }, error => {
                    commit('errorHandler', error)
                })
            }
        }).then(() => {
            return dispatch('getAllTypeLists')
        }).then((response) => {
            return dispatch('setBusinessAreaTypes', response.sysBusinessAreaTypeList)
        }).then(() => {
            return dispatch('getCurrentOrganizationList')
        }).then(() => {
            return dispatch('getCaseworkers')
        }).then(() => {
            return dispatch('getAssociatedOrganizationList')
        }).then(() => {
            return axios.post('/Account/GetDriveApplicationSettings').then((response) => {
                commit('setApplicationSettings', response.data)
            })
        })
    },
    ping: ({commit}, token) => {
        let tokenUrl
        if (token && (token.tokenId && token.tokenValue)) {
            tokenUrl = 'tokenid=' + token.tokenId + '&tokenvalue=' + token.tokenValue
        }
        return axios.get('/Account/Ping?' + tokenUrl).then((response) => {
            return new Promise((resolve, reject) => {
                if (response.data.authenticated) {
                    resolve(true)
                } else {
                    resolve(false)
                }
            })
        })
    },
    signOut: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios.post('/Account/SignOut').then(() => {
                resolve(true)
            }, error => {
                commit('errorHandler', error)
                reject(error)
            })
        })
    },
    getCurrentOrganizationList: ({ commit }) => {
        return axios.post('/Account/GetOrganizationList').then((response) => {
            commit('setCurrentOrganzationList', response.data)
            return response.data
        }, error => {
            commit('errorHandler', error)
        }).then(response => {
            if (!Object.keys(state.selectedOrganization).length && state.userInfo.selectedOrganization) {
                commit('setSelectedOrganization', state.userInfo.selectedOrganization)
            }
            return response
        })
    },
    changeOrganizationContext: ({ commit }, organizationId) => {
        return axios.post('/Account/ChangeOrganizationContext', {organizationId: organizationId}).then((response) => {
            commit('successHandler')
            return response
        }, error => {
            commit('errorHandler', error)
        })
    },
    setSelectedOrganizationId: ({ commit }, organizationId) => {
        // commit('setSelectedOrganizationId', organizationId)
        commit('setSelectedOrganization', organizationId)
    },
    getCaseworkers: ({ commit, dispatch }) => {
        let q = {}
        q['organizationUsersId'] = state.selectedOrganizationId
        q['UserGroupSystemNameFilterGroupList'] = []
        q['initialOrganization'] = false
        if (state.allLists.sysBusinessAreaTypeList) {
            state.allLists.sysBusinessAreaTypeList.forEach(fa => {
                q['UserGroupSystemNameFilterGroupList'].push('caseOwner_' + fa.systemName)
            })
        }
        return axios.post('/Account/GetAssociatedOrganizationUserList', q).then((response) => {
            commit('setCaseworkers', response.data)
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    getEntrepreneurs: ({ commit, dispatch }, organizationId) => {
        let q = {}
        q['organizationUsersId'] = organizationId
        q['UserGroupSystemNameFilterGroupList'] = [ 'contractor' ]
        q['initialOrganization'] = true
        state.allLists.sysBusinessAreaTypeList.forEach(fa => {
            // SKAL FIXES - CHECK EFTER
            if (state.userInfo.permissions.requests.enabled) {
                q['UserGroupSystemNameFilterGroupList'].push('caseOwner_' + fa.systemName)
            }
            q['UserGroupSystemNameFilterGroupList'].push('trustedContractor_' + fa.systemName)
        })
        return axios.post('/Account/GetAssociatedOrganizationUserList', q).then((response) => {
            commit('setEntrepreneurs', response.data)
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    // Code lists
    getAllTypeLists: ({ commit, dispatch, rootState }) => {
        return axios.post('/Codelist/GetAllCodeLists', {Inactive: false}).then((response) => {
            commit('addAllLists', response.data)
            commit('addBusinessAreaTypes', response.data.sysBusinessAreaTypeList)
            // We set the first supplytype as default
            if (response.data.sysBusinessAreaTypeList) {
                let defaultSupplyType = response.data.sysBusinessAreaTypeList[0]
                if (defaultSupplyType) {
                    commit('setSelectedSupplyType', defaultSupplyType.sysBusinessAreaTypeId)
                }
            }
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    },
    // Sets the selected supply type (for global use)
    async setSelectedSupplyTypeFromId ({ commit, dispatch }, supplyTypeId) {
        await commit('setSelectedSupplyType', supplyTypeId)
    },
    setSelectedMultipleSupplyTypeFromId: ({ commit }, supplyTypeId) => {
        commit('setSelectedMultipleSupplyType', supplyTypeId)
    },
    clearSelectedMultipleSupplyType: ({ commit }) => {
        commit('clearSelectedMultipleSupplyType')
    },
    // upload image
    uploadImage: ({commit, dispatch}, formData) => {
        return []
        // return axios.post('/Request/CreateUpdateRequestDocument', {requestId: '', fileName: '', description: ''}).then((response) => {
        //     commit('successHandler', response.status)
        //     return response.data
        // }, (response) => {
        //     commit('errorHandler', response)
        // })
    },
    // User history
    setRouterHistory: ({ dispatch, commit }, route) => {
        commit('setRouterHistory', route)
    },
    // Gets the existing work based on an adress search
    async getExistingWorkFromAddress ({ commit, rootState }, addressSearchObject) {
        let objectProperties = {
            enquiry: {
                parameter: {
                    whereOccurrenceAddressGuid: null,
                    whereOccurrenceAddress: null,
                    whereOccurrencePostalCode: null
                }
            },
            taskRequisition: {
                parameter: {
                    whereAddressGuid: null,
                    whereAddress: null,
                    wherePostalCode: null
                }
            }
        }
        // Supplytypes
        let ids = []
        for (let i = 0; i < rootState.dashboard.businessAreaTypes.length; i++) {
            ids.push(rootState.dashboard.businessAreaTypes[i].sysBusinessAreaTypeId)
        }

        // Enquiry
        objectProperties.enquiry.orderByColumnName = 'occurrenceDateTime'
        objectProperties.enquiry.orderByDescending = true
        objectProperties.enquiry.parameter.whereBusinessAreaTypeIdList = ids
        objectProperties.enquiry.parameter.whereIsClosed = true
        objectProperties.enquiry.parameter.whereOccurrenceAddressGuid = addressSearchObject.id ? addressSearchObject.id : null
        objectProperties.enquiry.parameter.whereOccurrenceAddress = addressSearchObject.street ? addressSearchObject.street : null
        objectProperties.enquiry.parameter.whereOccurrencePostalCode = addressSearchObject.zipCode ? addressSearchObject.zipCode : null

        // Task & Requisition
        objectProperties.taskRequisition.orderByColumnName = 'updated'
        objectProperties.taskRequisition.orderByDescending = true
        objectProperties.taskRequisition.parameter.whereBusinessAreaTypeIdList = ids
        objectProperties.taskRequisition.parameter.whereAddressGuid = addressSearchObject.id ? addressSearchObject.id : null
        objectProperties.taskRequisition.parameter.whereAddress = addressSearchObject.street ? addressSearchObject.street : null
        objectProperties.taskRequisition.parameter.wherePostalCode = addressSearchObject.zipCode ? addressSearchObject.zipCode : null
        objectProperties.taskRequisition.parameter.whereIsClosed = true

        let promiseEnquiries = null
        let promiseTasks = null

        if (state.userInfo.permissions.requests.enabled) {
            promiseEnquiries = new Promise((resolve, reject) => {
                resolve(axios.post('/Query/QueryRequestList/', objectProperties.enquiry))
            })
        }

        if (state.userInfo.permissions.tasks.enabled) {
            promiseTasks = new Promise((resolve, reject) => {
                resolve(axios.post('/Query/QueryTaskList/', objectProperties.taskRequisition))
            })
        }

        const values = await Promise.all([promiseEnquiries, promiseTasks])
        commit('setExistingEnquiriesFromAddress', values[0] ? values[0].data : [])
        commit('setExistingTasksFromAddress', values[1] ? values[1].data : [])
    },
    toggleMapState: ({ commit }, boolean) => {
        commit('setToggleMapState', boolean)
    },
    setNewCreatedObject: ({ commit }, object) => {
        return axios.post('/TaskActivity/CreateUpdateObjectDrive', object).then((response) => {
            return new Promise((resolve, reject) => {
                console.log(response)
                resolve(response.data)
            })
        }, (response) => {
            return new Promise((resolve, reject) => {
                console.log(response)
                reject(response)
            })
        })
    },
    setRemoveObject: ({ commit }, object) => {
        return axios.post('/TaskActivity/DeleteObjectDrive', object).then((response) => {
            return new Promise((resolve, reject) => {
                console.log(response)
                resolve(response.data)
            })
        }, (response) => {
            return new Promise((resolve, reject) => {
                console.log(response)
                reject(response)
            })
        })
    },
    setPermissions: ({ commit }, permissionArr) => {
        let permissions = {
            requests: {
                enabled: false
            },
            tasks: {
                enabled: false
            },
            requisitions: {
                enabled: false
            },
            kpi: {
                caseOwnerEnabled: false,
                contractorEnabled: false
            }
        }
        permissionArr.forEach(item => {
            // username
            if (item.type.toLowerCase() === 'username') {
                state.user.username = item.value
            }

            // SelectedOrganization
            if (item.type.toLowerCase() === 'selectedorganization') {
                state.userInfo.selectedOrganization = item.value
            }

            // DRIVE
            if (item.type === 'drive.role') {
                if (item.value.toLowerCase() === 'report') {
                    permissions.requisitions.enabled = true
                    permissions.kpi.contractorEnabled = true
                } else {
                    permissions.kpi.caseOwnerEnabled = true
                }
                let idx = item.value.indexOf('_')
                if (idx > -1) {
                    let prefix = item.value.substring(0, idx)
                    if (prefix.toLowerCase() === 'task') {
                        permissions.tasks.enabled = true
                    } else if (prefix.toLowerCase() === 'request') {
                        permissions.requests.enabled = true
                    }
                }
            }
        })
        if (state.isDesktop !== undefined) {
            permissions.isDesktop = state.isDesktop
        }
        commit('updatePermissions', permissions)
        commit('setTabs', permissions)
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/global.js